import { DealStatus } from 'components/common/types/Deal.types';

export const isDspSeatIdRequired = (bookingStatusCode: DealStatus | string): boolean =>
  !(bookingStatusCode === DealStatus.LIVE || bookingStatusCode === DealStatus.APPROVED);
